import * as R from 'ramda';
import React from 'react';
import {defer} from 'rxjs';

import {translate} from 'iss/strings';
import {getScales} from 'iss/service/GradingScaleService';
import {hasAdminRole} from 'iss/service/PartyService';
import subscribeTo from 'iss/utils/subscriptionUtils';
import {EditButton, NewButton} from 'iss/widgets/Buttons';
import {RestResultMessage} from 'iss/widgets/MessageBox';
import {FlexItem, FlexRow} from 'iss/widgets/Flex';

const GradingScaleList = subscribeTo(defer(getScales), 'scales', function GradingScaleList({scales}) {
  function getRow(scale) {
    return <tr key={scale.id} data-scale-id={scale.id}>
      <td className="scale-name">{scale.name}</td>
      <td className="scale-grades">{R.join(', ', scale.grades.map(R.prop('text')))}</td>
      <td className="scale-default-grade">{scale.defaultGrade? scale.defaultGrade.text:""}</td>
      <td>
        <EditButton disabled={!hasAdminRole()} className={scale.modifiable? "modify-scale":"view-scale"}
          canEdit={scale.modifiable}
          id={"modify-scale-"+scale.id}
          link={"/scales/"+scale.id}
          alt={translate('gradingScaleList.editScaleTooltip')}
          />
      </td>
    </tr>;
  }

  return <div>
    <FlexRow alignItems="baseline">
      <FlexItem>
        <h1>{translate('gradingScaleList.title')}</h1>
      </FlexItem>
      <FlexItem flex="none">
        { hasAdminRole() && <NewButton id="new-scale" link="/scales/new" text={translate('gradingScaleList.newScale')} /> }
      </FlexItem>
    </FlexRow>
    <table className="table table-striped">
      <thead>
        <tr>
          <th>{translate('gradingScaleList.scaleName')}</th>
          <th>{translate('gradingScaleList.scaleGrades')}</th>
          <th>{translate('gradingScaleList.defaultGrade')}</th>
          <th>{translate('common.editOrView')}</th>
        </tr>
      </thead>
      <tbody>
        {R.defaultTo([], scales).map(getRow)}
      </tbody>

    </table>
  </div>;
}, ({error}) => <RestResultMessage id="errorMessage" result={error} />);

export default GradingScaleList;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/GradingScaleList.jsx